import { BrandHeader, PublicFooter } from '../shell';
import shell from '../shell/shell.module.css';
import { ListingResults } from './listing-cards';
import { startOfDay, type PublicListingUnit } from './listing-model';
import styles from './property-view.module.css';

export interface PublicPropertyViewProps {
  organizationScope: string;
  organizationName: string;
  name: string;
  headline: string | null;
  description: string | null;
  /** One line: street, city, state. */
  address: string | null;
  photos: Array<{ url: string; alt: string | null }>;
  homes: PublicListingUnit[];
  now?: Date;
}

/**
 * A property's page (spec 5.2): its own words and photos from the property record, then the homes available in it.
 * The page binds to platform data only; nothing here is an editor-side copy.
 */
export function PublicPropertyView({ organizationScope, organizationName, name, headline, description, address, photos, homes, now }: PublicPropertyViewProps) {
  const today = startOfDay(now ?? new Date());
  const shown = photos.slice(0, 5);
  return (
    <div className={shell.page}>
      <BrandHeader>
        <header className={styles.head}>
          <h1 className={styles.title}>{name}</h1>
          {headline ? <p className={styles.headline}>{headline}</p> : null}
          {address ? <p className={styles.address}>{address}</p> : null}
        </header>
      </BrandHeader>
      <main>
        {shown.length > 0 ? (
          <div className={styles.gallery} data-count={shown.length}>
            {shown.map((photo, index) => (
              <img key={photo.url} className={styles.photo} src={photo.url} alt={photo.alt ?? ''} loading={index === 0 ? 'eager' : 'lazy'} decoding="async" />
            ))}
          </div>
        ) : null}
        {description ? <p className={styles.description}>{description}</p> : null}
        <h2 className={styles.homesTitle}>{homes.length === 0 ? 'No homes available right now' : homes.length === 1 ? '1 home available' : `${homes.length} homes available`}</h2>
        {homes.length > 0 ? <ListingResults units={homes} organizationSlug={organizationScope} organizationName={organizationName} moveIn={null} today={today} /> : null}
      </main>
      <PublicFooter />
    </div>
  );
}
